import { render } from "./VendorTransactionsList.vue?vue&type=template&id=b652a70a"
import script from "./VendorTransactionsList.vue?vue&type=script&lang=js"
export * from "./VendorTransactionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__